import { action } from '@/lib/api.js';

export const openAuditLogSlider = () => {
  action('SET_AUDIT_LOG_SLIDER', { open: true });
};

export const closeAuditLogSlider = () => {
  action('SET_AUDIT_LOG_SLIDER', { open: false });
};
